import { Router } from '@angular/router';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'sbnb-menu-item',
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.scss']
})
export class MenuItemComponent {
  @Input() item: any;
  @Input() badgeCounts: any;
  @Input() details: boolean = true;
  @Input() iconBase: string = '/assets/iconography/';

  constructor(private router: Router) { }

  visitLink() {
    if (this.item.external) {
      this.goToExternalLink(this.item.link);
    }
    else if (this.item.action) {
      this.item.action();
    }
    else {
      this.router.navigate([this.item.link]);
    }
  }

  goToExternalLink(link: string) {
    if (link) {
      window.location.href = link;
    }
  }
}
